import styled from 'styled-components';

export const RadioWrapper = styled.div`
  display: flex;
`;
